import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=5811d9ee&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=5811d9ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811d9ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5811d9ee')) {
      api.createRecord('5811d9ee', component.options)
    } else {
      api.reload('5811d9ee', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=5811d9ee&scoped=true&", function () {
      api.rerender('5811d9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Avatar.vue"
export default component.exports